import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import { Box, FormControlLabel, FormGroup, Switch } from "@mui/material";
import { useBoundDeep } from "@repo/shared/common";
import { BoundNumberField, BoundEuroField } from "@repo/shared/components";
import { useTranslation } from "next-i18next";
import React from "react";

import type { ProjectEditProps } from "./ProjectEditProps";
import type { Project } from "../types/ProjectTypes";

export const ProjectBudgetSection = (props: ProjectEditProps) => {
	const { t } = useTranslation();

	const { project, setProject, errors, setErrors } = props;

	const useBinding = <TValue,>(selector: (m: Project) => TValue) => {
		return useBoundDeep(project, setProject, selector, errors, setErrors);
	};

	const projectBudgetPriceField = useBinding((p) => p.budgetPrice);
	const projectTimeLimitField = useBinding((p) => p.budgetHours);

	return (
		<Box sx={{ display: "grid" }}>
			<Box sx={{ display: "flex" }}>
				<FormGroup sx={{ width: "20%" }} className="paddingGroup">
					<FormControlLabel
						control={
							<Switch
								onChange={(event) => {
									props.setProject({
										...props.project,
										hasBudgetPrice: event.target.checked,
									});
								}}
								checked={props.project.hasBudgetPrice ?? false}
							/>
						}
						label={t("has-budget-limit")}
					/>
				</FormGroup>
				{props.project.hasBudgetPrice ? (
					<Box sx={{ float: "left", width: "40%" }}>
						<BoundEuroField
							label={t("amount")}
							boundedValue={projectBudgetPriceField}
							additionalProps={{ className: "w-100 left" }}
						/>
					</Box>
				) : null}
			</Box>
			<Box sx={{ display: "flex" }}>
				<FormGroup sx={{ width: "20%" }} className="paddingGroup">
					<FormControlLabel
						control={
							<Switch
								onChange={(event) => {
									props.setProject({
										...props.project,
										hasBudgetHours: event.target.checked,
									});
								}}
								checked={props.project.hasBudgetHours ?? false}
							/>
						}
						label={t("has-time-limit")}
					/>
				</FormGroup>
				{props.project.hasBudgetHours ? (
					<Box sx={{ float: "left", width: "40%" }}>
						<BoundNumberField
							label={t("hours")}
							boundedValue={projectTimeLimitField}
							additionalProps={{ className: "w-100 left" }}
							icon={<AccessAlarmIcon />}
							iconBackgroundColor="#1a455c"
						/>
					</Box>
				) : null}
			</Box>
		</Box>
	);
};

ProjectBudgetSection.displayName = "ProjectBudgetSection";
